var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "filter-index" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "wishlist" }, [
        _c(
          "ol",
          { staticClass: "card-list" },
          _vm._l(_vm.items, function (item) {
            return _c(
              "li",
              { key: item.id, staticClass: "card-list__item" },
              [
                _c("FilterIndexItem", {
                  attrs: {
                    item: item,
                    "wishlist-cookie-name": _vm.wishlistCookieName,
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "cta-holder" }, [
          _vm.total >= _vm.visible
            ? _c(
                "button",
                {
                  staticClass: "btn btn--alt",
                  attrs: {
                    "aria-label": "Load more items",
                    title: "Click to load more items",
                  },
                  on: { click: _vm.loadMore },
                },
                [_vm._v("Load more")]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }